import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Button } from '../../../../components';
import { DISCOVERY_ROUTE_CONFIG } from '../../../../constants/routes';

const { Paragraph, Title, Text } = Typography;

export const SendingToInventory = ({ setStep, activeImportId }) => {
    const [countdown, setCountdown] = useState(10);
    const navigate = useNavigate();

    const navigateToInventory = useCallback(() => {
        navigate(DISCOVERY_ROUTE_CONFIG.inventory.path, {
            state: {
                active_import_id: activeImportId ?? null,
                has_pending_import: true,
            },
        });
    }, [navigate, activeImportId]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        if (countdown === 0) {
            navigateToInventory();
        }
    }, [countdown, navigateToInventory]);

    const handleGoToInventory = () => {
        navigateToInventory();
    };

    const handleUploadMore = () => {
        setStep(0);
    };

    return (
        <div className="sending-to-inventory">
            <Title level={2}>Data is being analyzed and sent to Inventory</Title>
            <Paragraph>
                Your RV Tools data is being processed and verified. When analysis is complete, your environment will
                appear in Inventory.
            </Paragraph>
            <div className="button-group">
                <Text>Redirecting to inventory in {countdown}s.</Text>
                <Button type="default" size="medium" onClick={handleUploadMore}>
                    Upload More
                </Button>
                <Button type="primary" size="medium" onClick={handleGoToInventory}>
                    Go to Inventory
                </Button>
            </div>
        </div>
    );
};
